'use client';

import React from 'react';
import Icon from '@/components/ui/AppIcon';

interface MissionStatementProps {
  mission: string;
  vision: string;
  approach: string;
}

const MissionStatement: React.FC<MissionStatementProps> = ({ mission, vision, approach }) => {
  return (
    <section id="mission" className="py-16 lg:py-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="font-heading font-bold text-3xl sm:text-4xl lg:text-5xl mb-4 text-neutral-50">
            Mission & Vision
          </h2>
          <p className="text-lg max-w-3xl mx-auto text-neutral-50">
            Guiding principles that drive excellence in laboratory leadership
          </p>
        </div>
        
        <div className="grid md:grid-cols-3 gap-8">
          <div className="bg-card rounded-2xl p-8 shadow-subtle hover:shadow-elevated transition-all duration-300 border border-border">
            <div className="w-16 h-16 bg-primary/10 rounded-xl flex items-center justify-center mb-6">
              <Icon name="RocketLaunchIcon" size={32} className="text-primary" />
            </div>
            <h3 className="font-heading font-bold text-2xl text-primary mb-4">
              Mission
            </h3>
            <p className="text-text-secondary leading-relaxed">
              {mission}
            </p>
          </div>
          
          <div className="bg-card rounded-2xl p-8 shadow-subtle hover:shadow-elevated transition-all duration-300 border border-border">
            <div className="w-16 h-16 bg-secondary/10 rounded-xl flex items-center justify-center mb-6">
              <Icon name="EyeIcon" size={32} className="text-secondary" />
            </div>
            <h3 className="font-heading font-bold text-2xl text-primary mb-4">
              Vision
            </h3>
            <p className="text-text-secondary leading-relaxed">
              {vision}
            </p>
          </div>
          
          <div className="bg-card rounded-2xl p-8 shadow-subtle hover:shadow-elevated transition-all duration-300 border border-border">
            <div className="w-16 h-16 bg-accent/10 rounded-xl flex items-center justify-center mb-6">
              <Icon name="LightBulbIcon" size={32} className="text-accent" />
            </div>
            <h3 className="font-heading font-bold text-2xl text-primary mb-4">
              Approach
            </h3>
            <p className="text-text-secondary leading-relaxed">
              {approach}
            </p>
          </div>
        </div>
      </div>
    </section>);

};

export default MissionStatement;